import {
  Advertisement,
  AdvertisementsService,
  CreateAdvertisementData,
} from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useCreateAdvertisement(
  mutationOptions?: Partial<
    UseMutationOptions<Advertisement, HttpError, CreateAdvertisementData>
  >,
) {
  return useMutation({
    mutationFn: AdvertisementsService.createAdvertisement,
    ...mutationOptions,
  });
}

export { useCreateAdvertisement };
